import {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
  useEffect,
} from "react";
import { api } from "../../Services/api";
import { IServiceAPI } from "../../Interfaces";
import { toast } from "react-toastify";

interface IServicesProviderData {
  services: IServiceAPI[];
  setServices: Dispatch<SetStateAction<IServiceAPI[]>>;
  addNewService: (service: IServiceAPI) => void;
  deleteService: (id: number | undefined) => void;
  editService: (service: IServiceAPI) => void;
  getServices: () => void;
}

interface ServicesProps {
  children: ReactNode;
}

const ServicesContext = createContext<IServicesProviderData>(
  {} as IServicesProviderData
);

export const ServicesProvider = ({ children }: ServicesProps) => {
  const [services, setServices] = useState<IServiceAPI[]>([]);

  useEffect(() => {
    api
      .get("/services")
      .then((response) => setServices([...response.data]))
  }, []);

  const getServices = () => {
    api
      .get("/services")
      .then((response) => setServices([...response.data]))
      .catch((_) => toast.error("Erro ao carregar serviços"));
  };

  const addNewService = (serviceToBeAdd: IServiceAPI) => {
    api
      .post("/services", serviceToBeAdd)
      .then((_) => {
        getServices();
        toast.success("Serviço adicionado");
      })
      .catch((_) => {
        toast.error("Erro ao adicionar serviço");
      });
  };

  const deleteService = (serviceId: number | undefined) => {
    api
      .delete(`/services/${serviceId}`)
      .then((_) => {
        getServices();
        toast.success("Serviço deletado");
      })
      .catch((_) => toast.error("Erro ao deletar serviços"));
  };

  const editService = (editedService: IServiceAPI) => {
    api
      .patch(`/services/${editedService.id}`, editedService)
      .then((_) => {
        getServices();
        toast.success("Serviço editado");
      })
      .catch((_) => {
        toast.error("Erro ao editar serviço");
      });
  };

  return (
    <ServicesContext.Provider
      value={{
        services,
        setServices,
        addNewService,
        deleteService,
        editService,
        getServices,
      }}
    >
      {children}
    </ServicesContext.Provider>
  );
};

export const useServices = () => useContext(ServicesContext);
